import { render } from "./YandexPaySplitWidget.vue?vue&type=template&id=32e0dbee&scoped=true"
import script from "./YandexPaySplitWidget.vue?vue&type=script&lang=js"
export * from "./YandexPaySplitWidget.vue?vue&type=script&lang=js"

import "./YandexPaySplitWidget.vue?vue&type=style&index=0&id=32e0dbee&scoped=true&lang=css"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e0dbee"]])

export default __exports__